import OtpInput from "react18-input-otp";
import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";
import { TextM } from "../../common/text";

export const ContentContainer = styled(ContentContainerBase)`
  align-items: center;
`;

export const Header = styled.div`
  width: 100%;
  height: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;

  padding-top: 30px;
  @media ${({ theme }) => theme.device.tablet} {
    padding-top: 50px;
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  height: 45%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
`;

export const Input = styled(OtpInput)`
  border: 0;
  border-bottom: 2px solid black;
  width: 45px;
  height: 50px;
  font-size: 25px;
  font-family: "Bold";
  margin-left: 5px;
  margin-top: 50px;
  justify-content: center;
  -webkit-appearance: none;
  &:focus {
    border-bottom: 2px solid #f44b59;
    outline: none;
  }
  @media ${({ theme }) => theme.device.tablet} {
    width: 70px;
    height: 80px;
    font-size: 35px;
  }
`;

export const Resend = styled.button`
  text-align: center;
  font-family: "Regular";
  font-size: 13pt;
  color: #f44b59;
  background-color: white;
  border: none;
  @media ${({ theme }) => theme.device.tablet} {
    font-size: 25px;
  }
`;

export const NextButton = styled.div`
  width: 80%;
  height: 50px;
  border-radius: 5px;
  background-color: ${({ isValidInput }) =>
    isValidInput ? "#f44b59" : "#eaeaea"};
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${({ theme }) => theme.device.tablet} {
    width: 450px;
    height: 70px;
  }
`;

export const NextButtonText = styled(TextM)`
  color: ${({ isValidInput }) => (isValidInput ? "#FFF" : "#9F9F9F")};
`;
